/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');

const createDeleteNamedCell = (name) => ({
	name,
	action: 'delete'
});

class UpdateNamedCellCommand extends RequestCommand {
	constructor(descr) {
		super();
		this.namedCell = descr;
		this.oldNamedCell = undefined;
	}

	get sheet() {
		return undefined;
	}

	createRequest(namedCell) {
		return super.createRequest({ namedCell });
	}
	getExecuteRequest() {
		return this.createRequest(this.namedCell);
	}
	getRedoRequest() {
		return this.createRequest(this.namedCell);
	}
	getUndoRequest() {
		return this.createRequest(this.oldNamedCell);
	}

	handleResult(result) {
		const { oldNamedCell } = result;
		if (!this.oldNamedCell) {
			this.oldNamedCell = oldNamedCell;
			this.oldNamedCell.action = 'update';
			if (oldNamedCell.formula == null && oldNamedCell.value == null) {
				this.oldNamedCell = createDeleteNamedCell(this.namedCell.name);
			}
		}
	}
}

module.exports = UpdateNamedCellCommand;
